import { render, staticRenderFns } from "./HeaderBlock.vue?vue&type=template&id=b0af6532&scoped=true&"
import script from "./HeaderBlock.vue?vue&type=script&lang=js&"
export * from "./HeaderBlock.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBlock.vue?vue&type=style&index=0&id=b0af6532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0af6532",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0af6532')) {
      api.createRecord('b0af6532', component.options)
    } else {
      api.reload('b0af6532', component.options)
    }
    module.hot.accept("./HeaderBlock.vue?vue&type=template&id=b0af6532&scoped=true&", function () {
      api.rerender('b0af6532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/HeaderBlock.vue"
export default component.exports